import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import WordPressModal from './WordPressModal';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { KNOWLEDGE_BASE_INSTALL_TRACKING_CODE } from '../../../utils/urls';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackingCodeModal = ({
  onClose,
  task
}) => {
  const {
    trackLink
  } = useModalTracker('TrackingCodeModal');
  if (task && task.link && task.link.includes('/wordpress')) {
    return /*#__PURE__*/_jsx(WordPressModal, {
      onClose: onClose
    });
  }
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    footer: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('install tracking code article'),
      url: KNOWLEDGE_BASE_INSTALL_TRACKING_CODE,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.trackingCode.heading"
    }),
    illustrationName: "mobile-onboarding-embed-tracking-code",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.trackingCode.description"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.trackingCode.li1"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.trackingCode.li2"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.trackingCode.li3"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.trackingCode.li4"
    })]
  });
};
TrackingCodeModal.propTypes = {
  onClose: PropTypes.func,
  task: PropTypes.object
};
export default TrackingCodeModal;